module.exports = __webpack_public_path__ + "img/lin.631aac4b.png";